module.exports = __webpack_public_path__ + "img/bp_gift6.8a28d815.png";